let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6YsGz")).then(() => parcelRequire('8rMrl'));